import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-registration-thanks',
  templateUrl: './registration-thanks.component.html',
  styleUrls: ['./registration-thanks.component.css']
})
export class RegistrationThanksComponent implements OnInit {

  timeLeft: number = 15;
  interval;

  constructor(    
    private router: Router,
    private route: ActivatedRoute
    ) { }

  ngOnInit() {
    

    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } 
    },1000)
    setTimeout(() => {
      window.location.href = '/areariservata?tabToLoad=profile';
    }, this.timeLeft*1000);
  }
 
}
